export default function Outcomes() {
  const outcomes = [
    {
      icon: 'ri-team-line',
      title: 'Enhanced Collaboration',
      description: 'Teams develop stronger communication and trust through shared creative challenges'
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Boosted Creativity',
      description: 'Movement and immersive environments unlock new perspectives and innovative thinking'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Improved Wellbeing',
      description: 'Mind-body integration reduces stress and enhances overall team wellness'
    },
    {
      icon: 'ri-user-smile-line',
      title: 'Inclusive Participation',
      description: 'Non-competitive format ensures everyone contributes regardless of skill level'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Memorable Experience',
      description: 'Tech-driven storytelling creates lasting positive associations with your team'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Measurable Impact',
      description: 'Digital tracking provides insights into team dynamics and individual growth'
    }
  ];

  return (
    <section id="outcomes" className="py-32 bg-gradient-to-b from-black via-[#0D1B2A] to-black">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <div className="inline-block px-6 py-2 bg-cyan-400/10 border border-cyan-400/30 rounded-full text-cyan-400 text-sm font-semibold tracking-wider mb-6">
            OUTCOMES &amp; BENEFITS
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
            What Your Team Will Gain
          </h2>
          <p className="text-gray-300 text-xl max-w-3xl mx-auto leading-relaxed">
            Groove &amp; Glow delivers measurable improvements in collaboration, creativity, and wellbeing 
            through an experience your team will never forget.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {outcomes.map((outcome, index) => (
            <div 
              key={index}
              className="group relative bg-gradient-to-br from-[#16213E] to-[#0F0F1A] rounded-2xl p-8 border border-cyan-400/20 hover:border-cyan-400/60 hover:-translate-y-2 hover:shadow-2xl hover:shadow-cyan-500/20 transition-all duration-300"
            >
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-cyan-400 to-blue-600 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${outcome.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-white mb-4">
                {outcome.title}
              </h3>
              
              <p className="text-gray-300 text-base leading-relaxed">
                {outcome.description}
              </p>

              <div className="absolute top-6 right-6 w-12 h-12 rounded-full bg-cyan-400/10 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-arrow-right-up-line text-cyan-400 text-xl"></i>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-24 bg-gradient-to-r from-orange-500/10 via-cyan-500/10 to-purple-500/10 rounded-3xl p-12 border border-white/10">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1">
              <div className="flex items-center gap-4 mb-6">
                <div className="flex items-center gap-2">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-orange-400 text-2xl"></i>
                  ))}
                </div>
                <span className="text-white text-xl font-bold">4.9/5 Team Satisfaction</span>
              </div>
              
              <blockquote className="text-2xl md:text-3xl font-serif text-white leading-relaxed mb-6 italic">
                "This workshop transformed how our team collaborates. The immersive environments made everyone 
                feel safe to express creativity."
              </blockquote>
              
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-cyan-400 to-blue-600 flex items-center justify-center border-3 border-white">
                  <i className="ri-user-line text-white text-2xl"></i>
                </div>
                <div>
                  <div className="text-white font-bold text-lg">Sarah Chen</div>
                  <div className="text-gray-400">Head of People Operations, TechCorp Singapore</div>
                </div>
              </div>
            </div>
            
            <div className="flex gap-4">
              <button className="w-14 h-14 rounded-lg bg-white flex items-center justify-center hover:scale-110 transition-transform cursor-pointer" aria-label="Previous testimonial">
                <i className="ri-arrow-left-line text-black text-2xl"></i>
              </button>
              <button className="w-14 h-14 rounded-lg bg-gradient-to-r from-cyan-400 to-blue-500 flex items-center justify-center hover:scale-110 transition-transform cursor-pointer" aria-label="Next testimonial">
                <i className="ri-arrow-right-line text-white text-2xl"></i>
              </button>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <a 
            href="#contact" 
            className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full text-white font-bold text-lg hover:shadow-2xl hover:shadow-cyan-500/50 transition-all hover:-translate-y-1 cursor-pointer whitespace-nowrap"
          >
            See Results For Your Team
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
